var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { defineComponent as _defineComponent } from 'vue';
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = { class: "columns is-mobile" };
const _hoisted_2 = { class: "column" };
const _hoisted_3 = { class: "label" };
const _hoisted_4 = /*#__PURE__*/ _createElementVNode("div", { class: "column" }, null, -1);
import { ref } from "vue";
import { doApiAction } from "@/core/api";
export default /*#__PURE__*/ _defineComponent({
    __name: 'ApplicationSupportDocumentUploadSection',
    props: {
        documents: {},
        title: {},
        upload: { type: Function },
        delete: { type: Function },
        getViewLink: { type: Function }
    },
    setup(__props) {
        const props = __props;
        const inProgressAction = ref(null);
        const uploadSupportingDocument = (uploadInfo) => {
            console.log("UL" + uploadInfo.file.name);
            doApiAction(inProgressAction, "uploadSupportingDocument", "Supporting document uploaded", "Failed to upload supporting document", () => __awaiter(this, void 0, void 0, function* () {
                yield props.upload(uploadInfo.file).finally(() => uploadInfo.onDone());
            }));
        };
        const deleteSupportDocument = (doc) => {
            doApiAction(inProgressAction, "deleteSupportDocument", "Support document deleted", "Failed to delete support document", () => __awaiter(this, void 0, void 0, function* () {
                yield props.delete(doc.id);
            }));
        };
        const downloadAttachment = (doc) => {
            doApiAction(inProgressAction, "downloadAttachment", null, "Failed to download attachment", () => __awaiter(this, void 0, void 0, function* () {
                yield props.getViewLink(doc.id)
                    .then((attachmentViewLink) => window.open(attachmentViewLink));
            }));
        };
        return (_ctx, _cache) => {
            const _component_DocumentUploadWidget = _resolveComponent("DocumentUploadWidget");
            return (_openBlock(), _createElementBlock("div", _hoisted_1, [
                _createElementVNode("div", _hoisted_2, [
                    _createElementVNode("label", _hoisted_3, _toDisplayString(_ctx.title) + " (.PNG or .PDF)", 1),
                    _createVNode(_component_DocumentUploadWidget, {
                        documents: _ctx.documents,
                        onUpload: _cache[0] || (_cache[0] = ($event) => (uploadSupportingDocument($event))),
                        onDelete: _cache[1] || (_cache[1] = ($event) => (deleteSupportDocument($event))),
                        onView: _cache[2] || (_cache[2] = ($event) => (downloadAttachment($event)))
                    }, null, 8, ["documents"])
                ]),
                _hoisted_4
            ]));
        };
    }
});
